/** Replace a container's contents with parsed HTML, without using innerHTML. */
export function setHTML(container: HTMLElement, html: string): void {
  const fragment = document.createRange().createContextualFragment(html);
  container.replaceChildren(fragment);
}

/** Escape a string so it is safe to interpolate into HTML text or attribute values. */
export function esc(s: string | number): string {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
